import React, { useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

import CommonButton from 'components/Buttons/CommonButton';
import Toolbar from 'components/Toolbar';
import utils from 'utils';

const ToolBar = () => {
  const t = utils.intl.useTranslator();
  const history = useHistory();
  const { path } = useRouteMatch();
  const [isArchive, setIsArchive] = useState(false);

  return (
    <>
      <Toolbar.BlueBar>
        <Toolbar.Left>
          <CommonButton
            id="report-toolbar-dashboard"
            scope="secondary"
            selected={!isArchive}
            value={t('report-dashboard')}
            action={() => {
              setIsArchive(false);
              history.push(`${path}`);
            }}
          />
          <CommonButton
            id="report-toolbar-archive"
            scope="secondary"
            selected={isArchive}
            value={t('report-archive')}
            action={() => {
              setIsArchive(true);
              history.push(`${path}/archive`);
            }}
          />
        </Toolbar.Left>
        <Toolbar.Right>
          <Toolbar.ModuleName>Reporting</Toolbar.ModuleName>
        </Toolbar.Right>
      </Toolbar.BlueBar>
    </>
  );
};

export default ToolBar;
